
export interface ReceiveContainerInput {
    containerId: string;
    warehouseId: string;
    associate: string;
    locale?: string;
    client: string;
    containerIdType?: string;
}

// No Output
export interface ReceiveContainerOutput {

}

export const buildReceiveContainerInput = (containerId: string, warehouseId: string, associate: string,
    locale: string, containerIdType?: string
): ReceiveContainerInput => {
    return {
        containerId,
        warehouseId,
        associate,
        locale,
        client: 'RIV_UI',
        containerIdType
    }
}
